export const BorrowerStatuses = {
	InComplete: 1,
	Pending: 2,
	ApprovedByCO: 3,
	Archived: 4,
};
